import HeaderSubHeader from "semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader";
import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import HeaderWithTag from "../../common/header_with_tag";
import { ICancelRemittanceRequest } from "../../types/types";
import TryCancelRemittance from "./try";
import { HeaderSubheader } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { HOST_API_URL } from "../../config";

const requestCode: ICancelRemittanceRequest = {
  ttno: "XRT00020675",
  refundType: "FULL",
  reasonForCancellation: "Description about the cancellation",
};

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": {
    "ttno": "XRT00020675",
    "refundType": "FULL",
    "reasonForCancellation": "Description about the cancellation"
  }
}`;

const failureResponseCode = `{
  "statusCode": 400,
  "message": "Transaction is not ready for modification",
  "errorCode": "DPI-4001",
  "data": null
}`;

function CancelRemittance() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Cancel Remittance</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Cancel Remittance
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Cancel a remittance"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          POST
                        </span>
                        {HOST_API_URL}/Remittances/CancelTransaction
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Requests cancellation of a previously submitted remittance. Provide the
                        transaction number and the refund type; a reason is optional. A 200
                        means the cancellation was accepted and processed by the back office;
                        confirm the resulting state with Get Transaction Details.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Request"
                          headerTag="request"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameter</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Required</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>ttno</td>
                                <td>string</td>
                                <td>
                                  Transaction number returned by Send Remittance. Your
                                  origRefNumber is not accepted here.
                                </td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>reasonForCancellation</td>
                                <td>string</td>
                                <td>
                                  Free-text reason recorded against the cancellation. If
                                  omitted, the response echoes null.
                                </td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>refundType</td>
                                <td>string</td>
                                <td>
                                  FULL or NET (see Refund Type in the Appendix). Only these
                                  two values are supported.
                                </td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={JSON.stringify(requestCode, null, 2)}
                          codeBlackText="Request"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>statusCode</td>
                                <td>integer</td>
                                <td>200 on success, otherwise the failure status</td>
                              </tr>
                              <tr>
                                <td>message</td>
                                <td>string</td>
                                <td>"Success", or the reason for the failure</td>
                              </tr>
                              <tr>
                                <td>errorCode</td>
                                <td>string</td>
                                <td>null on success; a stable DPI-xxxx code on failure</td>
                              </tr>
                              <tr>
                                <td>data</td>
                                <td>object</td>
                                <td>
                                  Echoes the cancellation request on success; null on
                                  failure, except request-validation failures, which carry
                                  a fixed descriptive string
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={failureResponseCode}
                          codeBlackText="Failure Example"
                          codeLanguage="json"
                        />
                        <p className="text-muted text-14 mt-3 mb-1">Failures this endpoint returns:</p>
                        <ul className="text-muted text-14 mb-0">
                          <li>DPI-1060 &mdash; ttno is missing or empty</li>
                          <li>DPI-4003 &mdash; refundType is missing or empty</li>
                          <li>
                            DPI-4001 &mdash; the transaction is not yours, is not in status
                            Ready, has already been downloaded by the paying agent, has
                            already been paid or cancelled, or the number is unknown
                          </li>
                          <li>
                            DPI-6001 &mdash; the authenticated user could not be resolved
                            to an agent account
                          </li>
                          <li>
                            HTTP 500 with DPI-9001 &mdash; the back-office cancellation
                            raised an error; query Get Transaction Details before retrying
                          </li>
                        </ul>
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                     Code Samples
                  </h5>

                  <TryCancelRemittance
                    codeBlackTitle="Request Example"
                    cancelRemittanceObject={requestCode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CancelRemittance;
